import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import useRouter from "@/hooks/router/useRoute"

import EquipmentsSearch from "@/app/settings/club/equipments/EquipmentsSearch"
import EquipmentsTable from "@/app/settings/club/equipments/EquipmentsTable"
import { useDevicesQuery } from "@/hooks/api/useDeviceQuery"
import { Device } from "@/types/device"
import { PAGE_SIZE } from "@/constants/pagination"

export default function Equipments() {
  const { t } = useTranslation()
  const router = useRouter()
  const [devices, setDevices] = useState<Device[] | undefined>()
  const [searchValue, setSearchValue] = useState("")
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
  })

  const { data, isLoading } = useDevicesQuery()

  const findIsMatch = (targetValue?: string) => {
    if (!targetValue) {
      return false
    }
    setPaginationModel({
      page: 0,
      pageSize: PAGE_SIZE,
    })

    return targetValue.toLocaleUpperCase().includes(searchValue.toLocaleUpperCase())
  }

  useEffect(() => {
    setDevices(
      data?.filter((device) => {
        if (!searchValue || searchValue.length < 2) {
          setPaginationModel({
            page: 0,
            pageSize: PAGE_SIZE,
          })

          return true
        }
        const { serialNumber, type, firmwareVersion } = device
        const isSerialNumberMatch = findIsMatch(serialNumber)
        const isTypeMatch = findIsMatch(type)
        const isFirmwareVersionMatch = findIsMatch(firmwareVersion)

        return isSerialNumberMatch || isTypeMatch || isFirmwareVersionMatch
      }),
    )
  }, [data, searchValue])

  const onSearch = (value: string) => setSearchValue(value)

  const onClickDelivery = () => router?.push("/settings/club/equipments/delivery")

  return (
    <div className="EquipmentsCont">
      <h1 className="page-title">{t("equipments")}</h1>
      <EquipmentsSearch onSearch={onSearch} onClickDelivery={onClickDelivery} />
      <EquipmentsTable
        data={devices}
        isLoading={isLoading}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
      />
    </div>
  )
}
